import { PropsWithChildren, PropsWithRef, ReactNode, forwardRef } from 'react';

interface ModeratorProps {
    children: ReactNode;
}

export const ModeratorLayout = forwardRef<PropsWithRef<HTMLDivElement>, PropsWithChildren<ModeratorProps>>(({ children }: ModeratorProps, ref) => (
    <div
        ref={ref}
        className="grid grid-rows-[auto_1fr_auto] grid-cols-1 bc:grid-rows-[auto_auto_1fr] bc:grid-cols-[minmax(250px,25%)_52%_1fr] bc:gap-1 h-dvh"
    >
        {children}
    </div>
));
